import React, {useEffect, useRef, useState} from 'react';
import {Link} from 'react-router-dom';
import Performer from '../../interfaces/Performer';
import './Events.css';
import {fetchPerformersByQuery} from '../../api/endpoints';
import {getPerformerUrlParams} from '../../utils/GlobalUtils';
import {useScreenSizeContext} from '../../providers/ScreenSizeProvider';
import {isRight} from 'fp-ts/lib/Either';

const TEVO_PAGE_SIZE = 100;
const PAGE_STEP = 10;

interface QueryPerformersProps {
    query: string;
    initialPerformers: Performer[];
    loading: boolean;
}

const QueryPerformers: React.FC<QueryPerformersProps> = ({query, initialPerformers, loading}) => {
    const pageNumber = useRef<number>(1);

    const [allPerformers, setAllPerformers] = useState<Performer[]>(initialPerformers);
    const [numToShow, setNumToShow] = useState<number>(PAGE_STEP);
    const [loadingMore, setLoadingMore] = useState<boolean>(false);
    const [noMore, setNoMore] = useState<boolean>(false);

    const {isMobile} = useScreenSizeContext();

    useEffect(() => {
        pageNumber.current = 1;
        setAllPerformers(initialPerformers);
        setNumToShow(PAGE_STEP);
        setNoMore(initialPerformers.length < TEVO_PAGE_SIZE);
    }, [initialPerformers]);

    const showMore = async () => {
        const localExhausted = numToShow >= allPerformers.length;
        if (localExhausted && !noMore && query) {
            setLoadingMore(true);
            const nextPage = pageNumber.current + 1;
            const responseEither = await fetchPerformersByQuery(query, true, nextPage);
            pageNumber.current = nextPage;
            if (isRight(responseEither)) {
                const fetched = responseEither.right;
                if (fetched.length === 0) {
                    setNoMore(true);
                } else {
                    setAllPerformers([...allPerformers, ...fetched]);
                    if (fetched.length < TEVO_PAGE_SIZE) {
                        setNoMore(true);
                    }
                }
            } else {
                console.error(responseEither.left);
                setNoMore(true);
            }
            setLoadingMore(false);
        }
        setNumToShow(prev => prev + PAGE_STEP);
    };

    const visible = allPerformers.slice(0, numToShow);
    const canShowMore = numToShow < allPerformers.length || !noMore;

    return (
        <div className='container-main'>
            <div className='content-main'>
                <div className={`${isMobile ? "left text-m" : "left text-xl"} `}>Performers</div>
                <br/>
                {loading ? (
                    <div className="loading-spinner"></div>
                ) : (
                    <div className='col'>
                        {visible.length > 0 ?
                            <>
                                {visible.map(performer => (
                                    <React.Fragment key={performer.tevoPerformerId}>
                                        <Link
                                            to={`/performer/${getPerformerUrlParams(performer)}`}
                                            className={`${isMobile ? "col event-bar" : "row event-bar"} `}
                                        >
                                            <div className='col align-start'>
                                                <div className='item-title'>{performer.name}</div>
                                                <div className={`${isMobile ? "text-xxs" : "text-xs-light"} `}>{performer.category?.name}</div>
                                            </div>
                                            <div className='gap'></div>
                                            <button className='action-button' style={isMobile ? {width: '100%', margin: '0px 20px'} : {}}>View Events</button>
                                        </Link>
                                        {isMobile && <div className='divider-margin'/>}
                                    </React.Fragment>
                                ))}
                                {loadingMore ? (
                                    <div>
                                        <br/><br/>
                                        <div className='loading-spinner'/>
                                    </div>
                                ) : canShowMore && (
                                    <div>
                                        <br/><br/>
                                        <button className='filter-button no-margin' onClick={showMore}>Show More</button>
                                    </div>
                                )}
                            </>
                            :
                            <>
                                <br/>
                                <br/>
                                <div className='text-s'>No Performers Found</div>
                                <br/>
                            </>
                        }
                        <br/>
                    </div>
                )}
            </div>
        </div>
    )
}

export default QueryPerformers;
